import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    '& .MuiDialog-container': {
      backgroundColor: "#000000B0"
    },
    '& .MuiPaper-root': {
      maxWidth: '80vw',
    },
  },
  dialogContentRoot: {
    [theme.breakpoints.down("md")]: {
      padding: "8px"
    }
  },
  dialogTitleWrapper: {
    margin: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogTitle: {
    flexGrow: 100,
  },
  closeDialogButton: {
    width: '5vw',
    maxWidth: 30,
    cursor: 'pointer',
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40vw',
    minHeight: '40vh',
  },
  deleteComponentDialogWrapper: {
    '& .MuiDialog-paper': {
      padding: 10,
    },
  },
}));

export default useStyles;
